import React from 'react';
import {GridContent, ContentNoCaption} from '../components/GridContent'
import '../style.css';

export default function About() {
  return (
    <div className="content load-first">
      <h2>Hi, I'm Nina!</h2>

      <p>I adore working in the intersections between writing, coding, editing, broadcasting and designing, which is why I'm pursuing an M.S. in Communication Data Science at USC. More than anything, I hope my ability to gather and share information meaningfully helps others understand more about the world around them.</p>

      <div className="grid load-second about">

        <GridContent src="img/Live.JPG" caption="Live production is one of the places I've been able to combine my different skill sets." alt="Photo of greenscreen livestreaming setup"/>

        <ContentNoCaption src="img/head.jpeg" alt="Photograph of Nina Moothedath"/>

        <GridContent src="img/boom.png" caption="Outside of work, I've enjoyed my time volunteering on the sets of several student films." alt="Photo of Nina using a boom mic on a film set"/>

      </div>
        
    </div>
  );
}
